import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_INQ003_Request,
  IAPI_INQ003_Response,
  IAPI_INQ015_Request,
  IAPI_INQ015_Response,
} from "../../../type/apiType";

// 施設照会参照
const httpAPI_INQ003 = async (
  param: IAPI_INQ003_Request
): Promise<IAPI_INQ003_Response> => {
  let res = await http.post(ApiUrl.API_INQ003, {
    ...param,
  });

  return res.data;
};

// 照会用コメント更新
const httpAPI_INQ015 = async (
  param: IAPI_INQ015_Request
): Promise<IAPI_INQ015_Response> => {
  let res = await http.post(ApiUrl.API_INQ015, {
    ...param,
  });

  return res.data;
};

export { httpAPI_INQ003, httpAPI_INQ015 };
